import { render, staticRenderFns } from "./ModalTitle.vue?vue&type=template&id=0d040836&scoped=true&"
import script from "./ModalTitle.vue?vue&type=script&lang=js&"
export * from "./ModalTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d040836",
  null
  
)

export default component.exports